import axiosInstance from '../api';

const offerDocumentsService = {
  getByOfferId: async (offerId: string) => {
    const res = await axiosInstance.get(`/offer-documents?offerId=${offerId}`);
    return res.data;
  },
};

export default offerDocumentsService;
